module.exports = __webpack_public_path__ + "assets/download.0ba1c69c9b4d3bab2104a519cd2a56cd.svg";